import { type InternalAssetMap, type AnyChainflipChain } from '@chainflip/utils/chainflip';
import { type SwapFee } from '@/shared/graphql/generated/explorer/graphql';

export const TABLE_POLL_INTERVAL = 10_000;
export const BOOST_FEE_FLIP_BURN_PERCENT = 0.025;

const POOL_FEE = 'Pool fee';
export const NETWORK_FEE = 'Network fee';
export const INGRESS_FEE = 'Deposit fee';
export const EGRESS_FEE = 'Broadcast fee';
export const BROKER_FEE = 'Broker fee';
export const BOOST_FEE = 'Boost fee';
export const REFUND_FEE = 'Refund fee';

export const feeTypeMap: Record<SwapFee['type'], string> = {
  BROKER: BROKER_FEE,
  NETWORK: NETWORK_FEE,
  BOOST: BOOST_FEE,
  INGRESS: INGRESS_FEE,
  EGRESS: EGRESS_FEE,
  LIQUIDITY: POOL_FEE,
  REFUND: REFUND_FEE,
};

export const FIRST_SWAP_DATE = '2023-12-19';
export const FIRST_DELEGATION_DATE = '2025-10-01';
export const FIRST_SUPPLY_DATE = '2025-12-24';

export const chainOrder: Record<AnyChainflipChain, number> = {
  Bitcoin: 0,
  Ethereum: 1,
  Solana: 2,
  Tron: 3,
  Bsc: 4,
  Arbitrum: 5,
  Assethub: 6,
  Polkadot: Infinity,
};

/**
 * we want to order the pools by most important chains first
 * each chain has its assets ordered with the native asset first, then whatever
 * other order for the tokens
 */
export const assetOrder: InternalAssetMap<number> & { Dot: number } = {
  // Bitcoin
  Btc: 0,
  // Ethereum
  Eth: 1,
  Usdc: 2,
  Usdt: 3,
  Wbtc: 4,
  Cbbtc: 5,
  Flip: 6,
  // Solana
  Sol: 7,
  SolUsdc: 8,
  SolUsdt: 9,
  // Tron
  Trx: 10,
  TrxUsdt: 11,
  // BSC
  Bnb: 12,
  BscUsdt: 13,
  // Arbitrum
  ArbEth: 14,
  ArbUsdc: 15,
  ArbUsdt: 16,
  // Assethub
  HubDot: 17,
  HubUsdc: 18,
  HubUsdt: 19,
  // Polkadot
  Dot: 20,
};

// Slippage default settings
export const DEFAULT_SLIPPAGE_PERCENT = 1.5;
export const DEFAULT_LPP_SLIPPAGE_PERCENT = 1;
export const DEFAULT_SWAP_DEADLINE_MINUTES = 5;

export const USE_DCA_V2 = true;
